// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6111":"14df6ac7","8336":"e7f52741"}[chunkId] || chunkId) + "." + {"2246":"bf9c88e9b7245d16","3745":"e3a9a0d2192ad2eb","6111":"981d5dc60a3e1221","7757":"3d11c7a9a0d08fee","8336":"5f3447385aa7df82"}[chunkId] + ".js";
};